module.exports = __webpack_public_path__ + "static/media/pricing-icon_starter.29acc724.svg";